/*** Alternative JS à srcset qui fonctionne aussi en background *************************************/
// Utiliser la classe img-check avec des attributs :
// data-src, data-src-small, data-src-medium, data-src-large

function isMobileRetina() {
	return window.devicePixelRatio > 1 && /Mobi|Android/i.test( navigator.userAgent );
}

function imgCheck() {
	let imgSize,
		mediumMinWidth,
		largeMinWidth,
		xlargeMinWidth;

	document.querySelectorAll('.img-check').forEach( function( thisEl ) {
		//On peut spécifier les largeurs quand les sizes s'appliquent dans le HTML
		if( ! thisEl.getAttribute('data-medium-min-width') ) {
			mediumMinWidth = 500;
		} else {
			mediumMinWidth = parseFloat( thisEl.getAttribute('data-medium-min-width') );
		}

		if( ! thisEl.getAttribute('data-large-min-width') ) {
			largeMinWidth = 1400;
		} else {
			largeMinWidth = parseFloat( thisEl.getAttribute('data-large-min-width') );
		}

		if( ! thisEl.getAttribute('data-xlarge-min-width') ) {
			xlargeMinWidth = 2000;
		} else {
			xlargeMinWidth = parseFloat( thisEl.getAttribute('data-xlarge-min-width') );
		}

		if( window.vWidth <= mediumMinWidth && ! isMobileRetina() ) {
			imgSize = 'small';
		} else if ( window.vWidth <= largeMinWidth || isMobileRetina() ) {
			imgSize = 'medium';
		} else if ( window.vWidth <= xlargeMinWidth ) {
			imgSize = 'large';
		} else {
			imgSize = 'xlarge';
		}

		// console.log( 'imgCheck : Choosing size "' + imgSize + '"' );

		let newSrc = thisEl.getAttribute('data-src-' + imgSize);

		if( newSrc ) {
			thisEl.setAttribute('data-src', newSrc);

			if( thisEl.getAttribute('data-original') ) {
				thisEl.setAttribute('data-original', newSrc);
			}

			if( thisEl.matches('img') ) {
				if( thisEl.getAttribute('src') ) {
					thisEl.setAttribute('src', newSrc);
				}
			} else {
				if( thisEl.style.backgroundImage ) {
					thisEl.style.backgroundImage = 'url(\'' + newSrc + '\')';
				}
			}
		}

		// Changer les valeurs de width et height
		if( thisEl.getAttribute( 'data-width-' + imgSize) ) {
			thisEl.setAttribute( 'width', thisEl.getAttribute('data-width-' + imgSize) );

			if( thisEl.getAttribute( 'data-height-' + imgSize) ) {
				thisEl.setAttribute( 'height', thisEl.getAttribute('data-height-' + imgSize) );
			} else {
				thisEl.removeAttribute( 'height' );
			}
		}
	} );
}

export default imgCheck;